import { initializeApp } from "firebase/app";
import { getFirestore, Timestamp } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAiviZm8dO6B8hHAXi9AZkKID0XD4JTgrI",
  authDomain: "gsv2-d2934.firebaseapp.com",
  projectId: "gsv2-d2934",
  storageBucket: "gsv2-d2934.appspot.com",
  messagingSenderId: "545307953038",
  appId: "1:545307953038:web:bc5b1b3ee1f88b590ac6df",
};
const app = initializeApp(firebaseConfig);
const projectFirestore = getFirestore(app);
const projectAuth = getAuth(app);
const storage = getStorage(app);
const timestamp = Timestamp;

export { projectFirestore, timestamp, projectAuth, storage };
